import { AlertTriangle } from 'lucide-react'
import type { DocumentExtractionConfidence } from '@klear/schema/document-processing'

export function traderUncertain(confidence: DocumentExtractionConfidence | null): boolean {
  return confidence !== null && confidence !== 'high'
}

export function TraderConfidence({ confidence }: { confidence: DocumentExtractionConfidence | null }) {
  if (!traderUncertain(confidence)) return null
  return (
    <span className="flex items-center gap-1 text-xs text-amber-600 dark:text-amber-500">
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden />
      {confidence} confidence
    </span>
  )
}
